/**
 * These values are used in a <select>, so they have to be in string form to work.
 * Before sending to the `set-qle-configuration` service, they must be converted to int!
 */
export const QLE_DATE = '0';
export const FIRST_OF_FOLLOWING_MONTH = '1';
